export default "__VITE_ASSET__OrAUNp6C__"